import React, { useState } from 'react'
import ReportLayout from '../../layouts/Report'

import useGetSchools from '../../../hooks/schools/useGetSchools'
import useGetCampuses from '../../../hooks/campuses/useGetCampuses'
import useGetUserScoreReport from '../../../hooks/analytics/useGetUserScoreReport'
import useExportUserScoreReport from '../../../hooks/analytics/useExportUserScoreReport'

import BarChart from '../../sub_components/charts/BarChart'
import ReportDatePicker from '../../sub_components/ReportDatePicker'
import FilterTable from '../../sub_components/FilterTable'

import { getDateString } from '../../../helpers/utility'

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/table'

const UserScoreReport = () => {
    const [schoolFilters, setSchoolFilters] = useState<number[]>([]);
    const [campusFilters, setCampusFilters] = useState<number[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    schoolFilters.forEach((id) => filterQuery.append("school_ids", id.toString()));
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));

    const { data: schools } = useGetSchools();
    const { data: campuses } = useGetCampuses();
    const { data: userScoreReport } = useGetUserScoreReport(filterQuery.toString());

    const { mutate: exportCsv } = useExportUserScoreReport();

    let filterTableDataColumns__Schools: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "School Name", identifier: "name" },
    ];
    let filterTableDataColumns__Campuses: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Campus Name", identifier: "name" },
    ];
    let filterTableDataColumns__UserScoreReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Status", identifier: "status" },
        { name: "Progress", identifier: "progress" },
        { name: "Created At", identifier: "created_at" },
    ];

    let filterTableData__Schools: IFilterableDataProps[] = [];
    let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__UserScoreReport: IFilterableDataProps[] = [];

    if (schools) {
        filterTableData__Schools = schools.map((school) => ({
            id: school.id,
            name: school.name,
        }));
    }

    if (campuses) {
        filterTableData__Campuses = campuses.map((campus) => ({
            id: campus.id,
            name: campus.name,
        }));
    }

    if (userScoreReport) {
        filterTableData__UserScoreReport = userScoreReport.table_data.map((user) => ({
            id: user.id,
            full_name: user.full_name,
            status: user.status,
            progress: user.progress,
            created_at: getDateString(user.created_at),
        }));
    }

    const onExportCsvReport = () => {
        exportCsv({
            payload: {
                filterQuery: filterQuery.toString(),
            }
        });
    }

    return (
        <ReportLayout>
            <div className='immersion_admin__careers_report'>
                <div className='immersion_admin__careers_report__header'>
                    <div className='immersion_admin__careers_report__header__content'>
                        <h2 className='immersion_admin__careers_report__header__content__title'>User Scores Report</h2>
                        <p className='immersion_admin__careers_report__header__content__description'>
                            This slide gives an overview of user resume scanner scores.
                        </p>
                    </div>
                    <div className='immersion_admin__careers_report__header__actions'>
                        <button className='immersion_admin__btn__primary immersion_admin__careers_report__header__actions__button' onClick={onExportCsvReport}>Export CSV</button>
                    </div>
                </div>

                <div className='immersion_admin__careers_report__chart_body'>
                    <div className='immersion_admin__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__Schools}
                            data={filterTableData__Schools}
                            enableFilters={true}
                            filters={schoolFilters}
                            setFilters={setSchoolFilters}
                        />
                        <FilterTable
                            columns={filterTableDataColumns__Campuses}
                            data={filterTableData__Campuses}
                            enableFilters={true}
                            filters={campusFilters}
                            setFilters={setCampusFilters}
                        />
                        <ReportDatePicker
                            required={true}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                        />
                    </div>
                    <div className='immersion_admin__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__UserScoreReport}
                            data={filterTableData__UserScoreReport}
                            enableFilters={false}
                            filters={[]}
                            setFilters={() => { }}
                        />
                        {userScoreReport?.status_chart_data.length ? (
                            <BarChart
                                width={600}
                                height={318}
                                data={userScoreReport?.status_chart_data ?? []}
                                xLabel="Period"
                                yLabel="No. of Resume Scans"
                                xTickAngle={90}
                                xInterval={0}
                            />
                        ) : (
                            <div className='immersion_admin__careers_report__chart__no_data'>
                                No analytics data available
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ReportLayout>
    )
}

export default UserScoreReport;